import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType,HttpHeaders } from '@angular/common/http';
import { TokenService } from '../../token.service';
import { MainService } from './main.service';
import { session } from '../../../environments/environment.session';
import { Utf8EncodingService } from 'src/app/md/service/utf8-encoding.service';
@Injectable({
  providedIn: 'root'
})
export class LogService {
  httpUrl:any;
  erpUser:any
  constructor(private http: HttpClient, private main: MainService, private token:TokenService , private utf8EncodingService:Utf8EncodingService) {
    this.httpUrl = this.main.httpUrl + '/systemdata';
  }
  module_cd:any
  le_id:any
  otp:any;
  async createLog(obj:any) {
    obj['module_cd'] = this.module_cd
    obj['le_id'] = this.le_id
    this.erpUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));;
    obj['login_id'] = this.erpUser['contact_phone']
    obj['login_type'] = 'OTP'
    obj['status'] = 'PASS'
    obj['otp'] = this.otp
    const resp = await this.http.post<any>(this.httpUrl + '/loginInfo/createLog', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }


}
